var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5496 12.0411C11.7522 12.0411 10.9913 11.6575 10.3826 10.9479C10.9852 10.1361 11.3748 9.13241 11.46 8.03289H12.5435C12.793 8.03289 13 7.81554 13 7.55344C13 7.29134 12.793 7.07399 12.5435 7.07399H11.0643C11.0522 7.07399 11.04 7.06759 11.0278 7.06759C11.0156 7.06759 11.0035 7.07399 10.9913 7.07399H9.9626V6.47945C9.9626 6.21735 9.75564 6 9.50608 6C9.25651 6 9.04956 6.21735 9.04956 6.47945V7.07399H6.46871C6.21914 7.07399 6.01219 7.29134 6.01219 7.55344C6.01219 7.81554 6.21914 8.03289 6.46871 8.03289H9.50608H10.5409C10.3157 10.2831 8.57477 12.0411 6.45652 12.0411C6.20696 12.0411 6 12.2584 6 12.5205C6 12.7826 6.20696 13 6.45652 13C7.71653 13 8.86695 12.4886 9.74956 11.6511C10.5226 12.5205 11.5026 13 12.5435 13C12.793 13 13 12.7826 13 12.5205C13 12.2584 12.7991 12.0411 12.5496 12.0411Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.79406 7.45869C3.33698 5.14417 5.14417 3.33698 7.45869 2.79406C9.13021 2.40198 10.8698 2.40198 12.5413 2.79406C14.8558 3.33698 16.663 5.14418 17.2059 7.4587C17.598 9.13021 17.598 10.8698 17.2059 12.5413C16.663 14.8558 14.8558 16.663 12.5413 17.2059C10.8698 17.598 9.13021 17.598 7.4587 17.2059C5.14418 16.663 3.33698 14.8558 2.79406 12.5413C2.40198 10.8698 2.40198 9.13021 2.79406 7.45869Z",
    fill: "white",
    fillOpacity: 0.15,
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLanguage);
export default __webpack_public_path__ + "static/media/menuLanguage.6c87e52791fa75979d4f99d4982e0667.svg";
export { ForwardRef as ReactComponent };